export interface LeadershipMember {
  id: string;
  name: string;
  title: string;
  bio: string;
  extendedBio: string;
  photoUrl: string;
  photoCredit?: string;
  linkedinUrl: string;
}

// TODO(content): populate once ZenFresh has a real, named leadership team to
// publish. Deliberately empty, following pressMentions.ts's precedent —
// inventing named executives with fake photos/LinkedIn URLs would be a
// specific, checkable false identity claim, not a harmless placeholder.
// LeadershipGrid.tsx renders a "coming soon" state while this is empty.
export const LEADERSHIP_TEAM: LeadershipMember[] = [];
